// See: https://webpack.js.org/concepts/module-federation/#dynamic-remote-containers
export const loadFederatedModule = async (
  remoteEntryFilenamePath: string,
  remoteModuleName: string, // ModuleFederationPlugin 'name'
  remoteModuleComponentPath: string, // ModuleFederationPlugin 'exposes' object key
) => {
  // eslint-disable-next-line
  const win = window as any;
  // Load the module only once and track it on the window object
  if (!win[remoteModuleName]) {
    // Add script tag for the module
    await new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = `${window.location.origin}${remoteEntryFilenamePath}`;
      script.type = "text/javascript";
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      // By default the session data is included because of the same origin
      // but this could cause us to hit the S3 8kb header limitation,
      // so we make the script load without session header to address this
      script.crossOrigin = "anonymous";
      document.head.appendChild(script);
    });
    // Initialize the sharing scope if it's the first time
    await __webpack_init_sharing__("default");
    const container = win[remoteModuleName];
    // @ts-expect-error No available types
    await container.init(__webpack_share_scopes__.default); // eslint-disable-line
  }
  // Load the specific module from the container
  const factory = await win[remoteModuleName].get(remoteModuleComponentPath);
  const Module = factory();
  return Module?.default || Module;
};
